// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#profileProgress .progressbar-text {
  background: #E6E5F5;
  border-radius: 50% 50% 51% 51%/50% 50% 50% 50%;
  display: flex;
  align-items: center;
  font-weight: bold;
  height: 65%;
  width: 65%;
  justify-content: center !important;
}

#profileProgress {
  position: relative;
}

.circle-progress {
  position: relative;
}

.timeline-item::before {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  background-color: white;
  border: 3px;
  border-radius: 50%;
  z-index: 1;
  justify-content: end;
}

.timeline-item.failed::before {
  border: 3px solid #B71334;
}

.timeline-item.successful::before {
  border: 3px solid #4EB969;
}

.timeline-item.pending::before {
  border: 3px solid #FCE74C;
}

.custom-radio input[type=radio] {
  display: none;
}
.custom-radio input[type=radio] + label {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}
.custom-radio input[type=radio] + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border-radius: 50px; /* this makes it rounded */
  border: 2px solid #000000; /* this is the border color */
  border-color: #000000; /* this is the border color when checked */
  opacity: 0.3;
}
.custom-radio input[type=radio]:checked + label:before {
  background-color: #4EB969; /* this is the background color when checked */
  border-color: #4EB969; /* this is the border color when checked */
  opacity: 1;
}

.custom-check2 input[type=checkbox] {
  display: none;
}
.custom-check2 input[type=checkbox] + label {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}
.custom-check2 input[type=checkbox] + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border-radius: 5px; /* this makes it rounded */
  border: 2px solid #000000; /* this is the border color */
  border-color: #000000; /* this is the border color when checked */
  opacity: 0.3;
}
.custom-check2 input[type=checkbox]:checked + label:before {
  background-color: #4EB969; /* this is the background color when checked */
  border-color: #4EB969; /* this is the border color when checked */
  opacity: 1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.custom-check input[type=checkbox] {
  display: none;
}
.custom-check input[type=checkbox] + label {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}
.custom-check input[type=checkbox] + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border-radius: 5px; /* this makes it rounded */
  border: 2px solid #cbd5e0; /* this is the border color */
  background-color: #fff; /* this is the background color when checked */
  border-color: #fff; /* this is the border color when checked */
  opacity: 0.3;
}
.custom-check input[type=checkbox]:checked + label:before {
  background-color: #4EB969; /* this is the background color when checked */
  border-color: #4EB969; /* this is the border color when checked */
  opacity: 1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.custom-toggle .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 17px;
}
.custom-toggle .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.custom-toggle .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
.custom-toggle .slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: -4px;
  bottom: -1px;
  background-color: white;
  transition: 0.4s;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}
.custom-toggle input:checked + .slider {
  background-color: #4EB969;
}
.custom-toggle input:focus + .slider {
  box-shadow: 0 0 1px #4EB969;
}
.custom-toggle input:checked + .slider:before {
  transform: translateX(24px);
}
.custom-toggle {
  /* Rounded sliders */
}
.custom-toggle .slider.round {
  border-radius: 34px;
}
.custom-toggle .slider.round:before {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/app.scss"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,kCAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAEA;EACE,kBAAA;AACF;;AACA;EACI,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AAEJ;;AAAA;EACI,yBAAA;AAGJ;;AADA;EACI,yBAAA;AAIJ;;AAFA;EACI,yBAAA;AAKJ;;AADE;EACI,aAAA;AAIN;AADI;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AAGN;AAAI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA,EAAA,0BAAA;EACA,yBAAA,EAAA,6BAAA;EAEA,qBAAA,EAAA,0CAAA;EACA,YAAA;AACN;AAEI;EACE,yBAAA,EAAA,8CAAA;EACA,qBAAA,EAAA,0CAAA;EACA,UAAA;AAAN;;AAOE;EACI,aAAA;AAJN;AAOI;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AALN;AAQI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA,EAAA,0BAAA;EACA,yBAAA,EAAA,6BAAA;EAEA,qBAAA,EAAA,0CAAA;EACA,YAAA;AAPN;AAUI;EACE,yBAAA,EAAA,8CAAA;EACA,qBAAA,EAAA,0CAAA;EACA,UAAA;EAEA,oEAAA;AATN;;AAeI;EACI,aAAA;AAZR;AAeM;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AAbR;AAgBM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA,EAAA,0BAAA;EACA,yBAAA,EAAA,6BAAA;EACA,sBAAA,EAAA,8CAAA;EACA,kBAAA,EAAA,0CAAA;EACA,YAAA;AAdR;AAiBM;EACE,yBAAA,EAAA,8CAAA;EACA,qBAAA,EAAA,0CAAA;EACA,UAAA;EAEA,oEAAA;AAhBR;;AAsBE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAnBJ;AAsBE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;AArBJ;AAwBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EAEA,gBAAA;EACA,+EAAA;EACA,mGAAA;EACA,6HAAA;AAtBJ;AA2BE;EACE,yBAAA;AAzBJ;AA4BE;EACE,2BAAA;AA1BJ;AA6BE;EAGE,2BAAA;AA3BJ;AA3BA;EAyDE,oBAAA;AA3BF;AA4BE;EACE,mBAAA;AA1BJ;AA6BE;EACE,kBAAA;AA3BJ","sourcesContent":["\n#profileProgress .progressbar-text{\n    background: #E6E5F5;\n    border-radius:50% 50% 51% 51% / 50% 50% 50% 50%; \n    display: flex;\n    align-items:center;\n    font-weight: bold;\n    height: 65%;\n    width: 65%;\n    justify-content: center !important;\n}\n\n#profileProgress {\n    position: relative;\n}\n.circle-progress {\n  position: relative;\n}\n.timeline-item::before {\n    content: '';\n    display: inline-block;\n    width: 15px;\n    height: 15px;\n    background-color: white;\n    border: 3px;\n    border-radius: 50%;\n    z-index: 1;\n    justify-content: end;\n}\n.timeline-item.failed::before {\n    border: 3px solid #B71334;\n}\n.timeline-item.successful::before {\n    border: 3px solid #4EB969;\n}\n.timeline-item.pending::before {\n    border: 3px solid #FCE74C;\n}\n\n.custom-radio{\n  input[type=\"radio\"] {\n      display: none;\n    }\n  \n    input[type=\"radio\"] + label {\n      position: relative;\n      padding-left: 30px;\n      cursor: pointer;\n    }\n  \n    input[type=\"radio\"] + label:before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 20px;\n      height: 20px;\n      border-radius: 50px; /* this makes it rounded */\n      border: 2px solid #000000; /* this is the border color */\n      // background-color: #f3f4f6; /* this is the background color when checked */\n      border-color: #000000; /* this is the border color when checked */\n      opacity: .3;\n    }\n  \n    input[type=\"radio\"]:checked + label:before {\n      background-color: #4EB969; /* this is the background color when checked */\n      border-color: #4EB969; /* this is the border color when checked */\n      opacity: 1;\n      // background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27%23fff%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e\") !important;\n      // background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e\") !important;\n    }\n}\n\n.custom-check2{\n  input[type=\"checkbox\"] {\n      display: none;\n    }\n  \n    input[type=\"checkbox\"] + label {\n      position: relative;\n      padding-left: 30px;\n      cursor: pointer;\n    }\n  \n    input[type=\"checkbox\"] + label:before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 20px;\n      height: 20px;\n      border-radius: 5px; /* this makes it rounded */\n      border: 2px solid #000000; /* this is the border color */\n      // background-color: #f3f4f6; /* this is the background color when checked */\n      border-color: #000000; /* this is the border color when checked */\n      opacity: .3;\n    }\n  \n    input[type=\"checkbox\"]:checked + label:before {\n      background-color: #4EB969; /* this is the background color when checked */\n      border-color: #4EB969; /* this is the border color when checked */\n      opacity: 1;\n      // background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27%23fff%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e\") !important;\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e\") !important;\n    }\n}\n\n\n.custom-check{\n    input[type=\"checkbox\"] {\n        display: none;\n      }\n    \n      input[type=\"checkbox\"] + label {\n        position: relative;\n        padding-left: 30px;\n        cursor: pointer;\n      }\n    \n      input[type=\"checkbox\"] + label:before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 20px;\n        height: 20px;\n        border-radius: 5px; /* this makes it rounded */\n        border: 2px solid #cbd5e0; /* this is the border color */\n        background-color: #fff; /* this is the background color when checked */\n        border-color: #fff; /* this is the border color when checked */\n        opacity: .3;\n      }\n    \n      input[type=\"checkbox\"]:checked + label:before {\n        background-color: #4EB969; /* this is the background color when checked */\n        border-color: #4EB969; /* this is the border color when checked */\n        opacity: 1;\n        // background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27%23fff%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e\") !important;\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e\") !important;\n      }\n}\n\n\n.custom-toggle{\n  .switch {\n    position: relative;\n    display: inline-block;\n    width: 40px;\n    height: 17px;\n  }\n  \n  .switch input { \n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: -4px;\n    bottom: -1px;\n    background-color: white;\n    -webkit-transition: .4s;\n    transition: .4s;\n    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n\n  }\n\n  \n  input:checked + .slider {\n    background-color: #4EB969;\n  }\n  \n  input:focus + .slider {\n    box-shadow: 0 0 1px #4EB969;\n  }\n  \n  input:checked + .slider:before {\n    -webkit-transform: translateX(24px);\n    -ms-transform: translateX(24px);\n    transform: translateX(24px);\n  }\n  \n  /* Rounded sliders */\n  .slider.round {\n    border-radius: 34px;\n  }\n  \n  .slider.round:before {\n    border-radius: 50%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
